import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography, Button } from "@mui/material";
import { Cancel } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStoreImages,
  setDeleteMode,
  selectImages,
  selectIsDeleteMode,
  selectLoading,
  selectSelectedImages,
} from "../../../Store/Gmb/gmbImageSlice";
import "../style.css";
import ImageCarousel from "./ImageCarousel";
import DeleteSVG from "../DeleteSVG";
import AddImages from "./AddImages";
import DeleteImages from "./DeleteImages";
import { useIsGmbAdmin } from "../hook/useIsGMBAdmin";
import AddPost from "./AddPost";
import {
  fetchAllPosts,
  selectAllPosts,
  selectLoadingState,
  selectSelectedPosts,
  setSelectedPost,
} from "../../../Store/Gmb/gmbPostSlice";
import DeletePostModal from "./DeletePosts";
import PostImageCarousel from "./PostImageCarousel";

const PostView = ({ accountId, locationId, disabled }) => {
  const dispatch = useDispatch();
  const posts = useSelector(selectAllPosts);
  const [isDeleteMode, setIsDeleteMode] = useState(false);
  const isFetchingPostImages = useSelector((state) =>
    selectLoadingState(state, "fetchAllPosts"));

  const isAdmin = useIsGmbAdmin();

  useEffect(() => {
    if (accountId && locationId) {
      dispatch(
        fetchAllPosts({ account_id: accountId, location_id: locationId })
      );
    }
  }, [accountId, locationId, dispatch]);

  const handleDeleteMode = () => {
    setIsDeleteMode(!isDeleteMode);
    dispatch(setSelectedPost([]));
  };

  const handleDeleteComplete = () => {
    // console.log("handleDeleteComplete");
    setIsDeleteMode(false);
  };

  const handleImageUpdate = () => {
    dispatch(fetchAllPosts({ account_id: accountId, location_id: locationId }));
  };
  

  return (
    <Box sx={{ mb: 0.5 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 0.5,
          py: 0.5,
        }}
      >
        <Typography
          sx={{ fontWeight: 400, fontSize: "1.25rem", color: "#172128" }}
        >
          Posts
        </Typography>
        {isAdmin && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
            }}
          >
            <AddPost />

            <DeletePostModal
              onImageUpdate={handleImageUpdate}
              onDeleteComplete={handleDeleteComplete}
              // setDeleteMode={setIsDeleteMode}
            />
            {!isDeleteMode && (
              <Box onClick={!disabled ? handleDeleteMode : undefined}>
                <DeleteSVG
                  disabled={posts?.length === 0 || disabled}
                  fillColor={
                    posts?.length === 0 || disabled ? "#D3D3D3" : "#EC221F"
                  }
                />
              </Box>
            )}
            {isDeleteMode && (
              <Button
                sx={{
                  backgroundColor: "#ECE6F0",
                  color: "white",
                  px: 2,
                  py: 1,
                  borderRadius: "1rem",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  textTransform: "capitalize",
                  boxShadow: "0 4px 8px 3px rgba(0,0,0,0.15)",
                }}
                onClick={handleDeleteMode}
              >
                <Cancel htmlColor="#65558F" sx={{ mr: 1, fontSize: "18px" }} />
                <Typography sx={{ fontWeight: 500, color: "#65558F" }}>
                  Cancel
                </Typography>
              </Button>
            )}
          </Box>
        )}
      </Box>

      {isFetchingPostImages ? (
        <Box
          sx={{
            width: "100%",
            height: "240px",
            color: "#EC221F",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
          {posts?.length === 0 ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "240px",
                width: "100%",
              }}
            >
              <Typography color="error">No Posts available.</Typography>
            </Box>
          ) : (
            <PostImageCarousel
              imageList={posts.map((item) => item?.url)}
              deleteMode={isDeleteMode}
              postType={posts.map((item) => item?.topicType)}
              postState={posts.map((item) => item?.state)}
            />
          )}
        </Box>
      )}
    </Box>
  );
};

export default PostView;
